import { ChangeDetectionStrategy, Component, Input, signal } from '@angular/core';
import { GalaxyAbstractFilterChip, GalaxyFilterValueInterface } from '@vendasta/galaxy/filter/chips';

/**
 * Chip label for identity-field filters.
 *
 * An ID has no friendlier display form available client side, so the raw value is shown as typed.
 * GalaxyFilterInputOverride requires a chip alongside every input override, and one chip serves
 * every identity field since none of them need per-type rendering.
 *
 * Several IDs collapse to the first one plus a count of the rest, matching how the library labels
 * its own multi-value chips. The count keys off how many values were applied rather than the
 * operator, which the chip is never given - and it works out the same, since only the "is any"
 * family of operators can hold more than one value.
 */
@Component({
  selector: 'crm-id-filter-chip',
  template: `{{ displayValue() }}`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IdFilterChipComponent implements GalaxyAbstractFilterChip {
  readonly displayValue = signal('');

  @Input() set initialValue(values: GalaxyFilterValueInterface[]) {
    const ids = (values ?? []).map((value) => value?.string ?? '').filter((id) => id.length > 0);
    if (ids.length === 0) {
      this.displayValue.set('');
      return;
    }
    if (ids.length === 1) {
      this.displayValue.set(ids[0]);
      return;
    }
    this.displayValue.set(`${ids[0]} +${ids.length - 1}`);
  }
}
